import { render, staticRenderFns } from "./enrollment-banner.vue?vue&type=template&id=65ff0f99&scoped=true&"
import script from "./enrollment-banner.vue?vue&type=script&lang=js&"
export * from "./enrollment-banner.vue?vue&type=script&lang=js&"
import style0 from "./enrollment-banner.vue?vue&type=style&index=0&id=65ff0f99&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ff0f99",
  null
  
)

export default component.exports